import React from 'react';

export interface APIErrorResponse {
  MemberNames: string[];
  'Error Message': string;
  'Validation Results'?: APIErrorResponse[];
}

interface QuoteAPIErrorListProps {
  errors: APIErrorResponse[];
}

const ErrorList: React.FC<{ errors: APIErrorResponse[] }> = ({ errors }) => {
  return (
    <ul className="p-4">
      {errors?.map((error) => (
        <li
          className="text-text/body-primary pb-4 list-disc"
          key={error['Error Message']} // Ensure this key is unique in case of duplicate error messages
        >
          {error['Error Message']}
          {error['Validation Results'] && (
            <ErrorList errors={error['Validation Results']} />
          )}
        </li>
      ))}
    </ul>
  );
};

const QuoteAPIErrorList: React.FC<QuoteAPIErrorListProps> = ({ errors }) => {
  return <ErrorList errors={errors} />;
};

export default QuoteAPIErrorList;
